import React from "react";
import "../../../../assets/scss/components/toc/orderBook/generic/obCheckbox.scss";

export interface IObCheckboxProps {
	checked: boolean; // true if checkbox is checked, else false
	children?: string | React.ReactElement; // the text/element for label
	name: string; // name for input checkbox
	disabled?: boolean; // if disabled then pass true
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
}

const ObCheckbox: React.FC<IObCheckboxProps> = (props: IObCheckboxProps) => {
	return (
		<label className={"ob_checkbox" + (props.disabled ? " disabled" : "")}>
			<input type="checkbox" onChange={props.onChange} checked={props.checked || false} name={props.name} />
			<span className="checked edel-icon-tick"></span>
			{props.children && <span className="checkbox_label">{props.children}</span>}
		</label>
	);
};

export default ObCheckbox;
